import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@dotlottie/player-component';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./contexts/AuthContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import ErrorBoundary from './components/common/ErrorBoundary';
import logger from './utils/logger';
import reportWebVitals from './reportWebVitals';

// Initialize Production Console Sanitizer & Global Error Handlers
logger.initGlobalConsole();
logger.initGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider> 
        <CurrencyProvider>
          <App />
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

reportWebVitals();

